/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncomeOutcomeStoreModel { 
    storeId?: number;
    dayBeforeRemainder?: number;
    income?: number;
    selectedDayRemainder?: number;
    discardedAmount?: number;
    refundedAmount?: number;
    exportAmount?: number;
    confectionaryAmount?: number;
    inventoryAmount?: number;
}

